import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'grid',
      gridTemplateColumns: ({ personaCount = 5 }) => 'repeat(' + personaCount + ', minmax(0,1fr))',
      gap: theme.spacing(1),
    },
    buttonPersona: {},
    buttonMore: {
      height: 122,
      borderRadius: theme.shape.borderRadius,
      border: '1px solid',
      borderColor: COLORS.primary.light,
      backgroundColor: COLORS.neutral.white,
    },
    buttonPersonaReducedHeight: {
      height: 108,
    },
    popper: {
      zIndex: theme.zIndex.absoluteElement,
    },
    popperContentWrapper: {
      minHeight: 190,
      display: 'flex',
      alignItems: 'end',
      marginBottom: 10,

      '&$bottom': {
        alignItems: 'start',
        marginBottom: 0,
        marginTop: 10,
      },
    },
    bottom: {},
  }),
  { name: 'PersonaSelector' }
);
